export function checkEmpty(e) {
    if ((Array.isArray(e) && e.length === 0) || e === '' || e === null || e === undefined) {
        return false
    } else {
        return true
    }
}